import DateRangePicker from "../DateRangePicker";
import { RANGES, readRange, withParams } from "../../web-analytics";
import type { DateRange } from "../../date-range";

/** The API refuses a window over 400 days (end date included). */
const MAX_SPAN_DAYS = 400;

/**
 * Today, the last 7 / 30 / 90 days, this or last week, month to date, last month,
 * or custom dates, in the site's own time zone. Every choice is a URL change
 * (filters and site are kept), so the back button undoes it.
 */
export default function RangePicker({ search, go, zone }: { search: URLSearchParams; go: (next: string) => void; zone: string }) {
  const current = readRange(search);
  const value: DateRange = current.range === "custom" ? { key: "custom", from: current.from, to: current.to } : { key: current.range };
  const change = (next: DateRange) =>
    go(withParams(search, next.key === "custom" ? { range: "custom", from: next.from, to: next.to } : { range: next.key, from: null, to: null }));
  return <DateRangePicker value={value} onChange={change} presets={RANGES} rollingEnd="today" maxDays={MAX_SPAN_DAYS} zone={zone} label="Date range" />;
}
